import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from '@spothero/ui/button';
import HorizontalRule from '@spothero/ui/horizontal-rule';
import FormElementError from '@spothero/ui/form-element-error';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import EnvironmentUtils from '@spothero/utils/environment';
import SHLoader from 'common/loader/SHLoader';
import FacilityAPI from 'api/facility';
import SearchTracking from 'utils/search-tracking';
import SpotUtils from 'utils/spot';
import WithConfig from 'config/WithConfig';
import SpotListItem from 'search/spot-list/SpotListItem';

class RecommendedSpotsModal extends Component {
    static propTypes = {
        facilityIncludes: PropTypes.string.isRequired,
        isAdmin: PropTypes.bool.isRequired,
        recommendedSpotsUnavailableReason: PropTypes.string,
        latitude: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired,
        starts: PropTypes.string.isRequired,
        ends: PropTypes.string.isRequired,
        timezone: PropTypes.string.isRequired,
        isMonthly: PropTypes.bool.isRequired,
        onHidden: PropTypes.func.isRequired,
        onBackToSearchClick: PropTypes.func.isRequired,
        fetchSpotRates: PropTypes.func.isRequired
    };
    state = {
        isLoading: true,
        recommendedSpots: null,
        unavailableMessage: null
    };

    constructor(props) {
        super(props);

        this._isMobile = EnvironmentUtils.isMobileDevice();
    }

    componentDidMount() {
        SearchTracking.updateAction('UNAVAILABLE_SHOW_NEARBY');

        this._getRecommendedSpots();
    }

    _onDifferentDateClick = evt => {
        evt.preventDefault();

        this._modal.hide(true);
    }

    _onBookSpotClick = spot => {
        this._modal.hide();

        const {
            isMonthly,
            fetchSpotRates
        } = this.props;
        const {
            spotId,
            selectedRate: {
                starts,
                ends,
                fullRule,
                fullUrl
            }
        } = spot;

        fetchSpotRates({
            spotId,
            starts,
            ends,
            includeFacility: true,
            meta: {
                monthly: isMonthly,
                spotId,
                rid: fullRule,
                newUrl: fullUrl
            }
        });
    }

    async _getRecommendedSpots() {
        const {
            facilityIncludes,
            latitude,
            longitude,
            starts,
            ends,
            isMonthly,
            timezone
        } = this.props;
        const {
            searchUUID,
            actionUUID,
            action
        } = SearchTracking.getValues();
        const recommendedSpotsParams = {
            distance__lt: 1609, // eslint-disable-line camelcase
            sort: 'distance',
            sort_order: 'asc', // eslint-disable-line camelcase
            include: facilityIncludes,
            limit: 10,
            starts,
            ends,
            monthly: isMonthly,
            latitude,
            longitude,
            search_id: searchUUID, // eslint-disable-line camelcase
            action_id: actionUUID, // eslint-disable-line camelcase
            action
        };

        try {
            const response = await FacilityAPI.getRecommendedSpots(recommendedSpotsParams);
            const recommendedSpots = response.data.data.results;

            if (recommendedSpots.length) {
                const newSpots = [];

                recommendedSpots.forEach((recommendedSpot, i) => {
                    if (i > 2) { return; }

                    const spotData = SpotUtils.prepare({
                        spot: recommendedSpot,
                        searchRequest: {
                            monthly: isMonthly,
                            starts,
                            ends
                        },
                        timezone
                    });

                    spotData.imageLoaded = true;
                    newSpots.push(spotData);
                });

                this.setState({
                    isLoading: false,
                    recommendedSpots: newSpots
                });
            } else {
                this.setState({
                    isLoading: false,
                    unavailableMessage: 'Sorry, no nearby spots found at this time.'
                });
            }
        } catch (error) {
            console.log(error); // eslint-disable-line no-console
        }
    }

    render() {
        const {
            isAdmin,
            onHidden,
            recommendedSpotsUnavailableReason,
            onBackToSearchClick
        } = this.props;
        const {
            isLoading,
            recommendedSpots,
            unavailableMessage
        } = this.state;

        return (
            <Modal
                ref={node => { this._modal = node; }}
                className="RecommendedSpotsModal"
                title="Spot Unavailable"
                onHidden={onHidden}
            >
                <ModalContent>
                    {(isAdmin && recommendedSpotsUnavailableReason) &&
                        <FormElementError>{recommendedSpotsUnavailableReason}</FormElementError>
                    }
                    <HorizontalRule lineStyle="dotted">Other Spots Nearby</HorizontalRule>
                    {isLoading && <SHLoader />}
                    {recommendedSpots &&
                        <div className="SpotList recommended-spots">
                            {recommendedSpots.map(spot => {
                                return (
                                    <SpotListItem
                                        key={spot.spotId}
                                        spot={spot}
                                        showAmenities={false}
                                        onBookSpotClick={this._onBookSpotClick}
                                        onShowDetailsClick={this._onBookSpotClick}
                                    />
                                );
                            })}
                        </div>
                    }
                    {unavailableMessage &&
                        <p className="RecommendedSpotsModal-unavailable-message">{unavailableMessage}</p>
                    }
                    <HorizontalRule lineStyle="dotted">or</HorizontalRule>
                    <div className="FormActions">
                        <Button
                            className={(!this._isMobile) ? 'Button-space-after' : null}
                            color="secondary"
                            onClick={this._onDifferentDateClick}
                        >
                            Change Date/Time
                        </Button>
                        <Button
                            className={(!this._isMobile) ? 'Button-space-before' : null}
                            color="secondary"
                            onClick={onBackToSearchClick}
                        >
                            Return to Map
                        </Button>
                    </div>
                </ModalContent>
            </Modal>
        );
    }
}

export default WithConfig(RecommendedSpotsModal);
